var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultantCommissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_990",
    "data-name": "Group 990",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M4.8,1.92A2.88,2.88,0,1,1,1.92,4.8,2.883,2.883,0,0,1,4.8,1.92M4.8,0A4.8,4.8,0,1,0,9.6,4.8,4.8,4.8,0,0,0,4.8,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M64.8,61.92a2.88,2.88,0,1,1-2.88,2.88,2.883,2.883,0,0,1,2.88-2.88m0-1.92a4.8,4.8,0,1,0,4.8,4.8A4.8,4.8,0,0,0,64.8,60",
    transform: "translate(-45.6 -45.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M22.248,4.8a.471.471,0,0,1,.339.141l.849.848a.48.48,0,0,1,0,.679L6.465,23.436a.48.48,0,0,1-.679,0l-.849-.848a.48.48,0,0,1,0-.679L21.908,4.938a.471.471,0,0,1,.339-.141m0-1.92a2.392,2.392,0,0,0-1.7.7L3.58,20.551a2.4,2.4,0,0,0,0,3.394l.849.848a2.4,2.4,0,0,0,3.394,0L24.794,7.823a2.4,2.4,0,0,0,0-3.394l-.849-.849a2.392,2.392,0,0,0-1.7-.7",
    transform: "translate(-2.187 -2.187)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultantCommissionIcon);
export default __webpack_public_path__ + "static/media/consultant_commission_icon.e066be8cd198692a118d85d330b3c34f.svg";
export { ForwardRef as ReactComponent };